import visa from './img/visa.svg';
import mastercard from './img/mastercard.svg';
import jcb from './img/jcb.svg';
import discover from './img/discover.svg';
import americanExpress from './img/american-express.svg';
import unknownBrand from './img/unknown.png';

export const UNKNOWN = 'unknown';
export const CARD_NUMBER_PLACEHOLDER = 'XXXX XXXX XXXX XXXX';

export const enum CARD_BRAND {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
  JCB = 'jcb',
}

export const CARD_BRAND_IMAGES: Record<CARD_BRAND | typeof UNKNOWN, string> = {
  [CARD_BRAND.DISCOVER]: discover,
  [CARD_BRAND.AMEX]: americanExpress,
  [CARD_BRAND.JCB]: jcb,
  [CARD_BRAND.MASTERCARD]: mastercard,
  [CARD_BRAND.VISA]: visa,
  [UNKNOWN]: unknownBrand,
};
